import "../PagesStyling/Error.css";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404"></div>
        <h1>404</h1>
        <h2>Oops! Page Not Found</h2>
        <p>
          Sorry but the page you are looking for does not exist, have been
          removed, name changed or is temporarily unavailable.
        </p>
        <Link className="back-link" to='/assets'>Back to Assets</Link>
      </div>
    </div>
  );
};

export default ErrorPage;
